export type ConsentStatusMessages = {
  canceled: string;
  completed: string;
  notCompleted: string;
  pending: string;
};

export const CONSENT_STATUS_MESSAGES: ConsentStatusMessages = {
  canceled: "Cancelado",
  completed: "Concedido",
  notCompleted: "Não concedido",
  pending: "Pendente",
};

export default CONSENT_STATUS_MESSAGES;
